import { httpHelper } from '@/utils'

const state = {
    isLoadingTrips: false,
    isTripDirectionVisible: true,
    selectedTripId: null,
    trips: [],
}

const getters = {
    selectedTrip(state) {
        return state.selectedTripId
            ? state.trips.find(trip => trip.id === state.selectedTripId)
            : null
    },
    totalDistance(state) {
        return state.trips.reduce((total, trip) => {
            if (trip.trip_distance) {
                return total + trip.trip_distance
            }
            return total
        }, 0)
    },
}

const actions = {
    async loadTrips({ commit }, { assetId, fromDate, toDate, network }) {
        commit('setLoadingTrips', true)
        commit('setTrips', [])
        const assetType = network === 'bluetooth' ? 'trailer_asset' : 'asset'

        let url =
            'measurementseries-full/?' +
            `${assetType}=${assetId}` +
            `&start=${encodeURIComponent(fromDate)}` +
            `&end=${encodeURIComponent(toDate)}` +
            `&limit=${process.env.VUE_APP_LIMIT_RECORDS_PER_REQUEST}`
        const trips = []
        while (url) {
            const { data } = await httpHelper.get(url)
            trips.push(...data.results)
            url = data.next
        }

        // We need to het the measurement in ascending order (on timestamp), so that
        // on the trip history layer we can look forward and determine the travel direction of the asset.
        for (const trip of trips) {
            if (trip.measurements) {
                trip.measurements.sort(
                    (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
                )

                const lastWithOdometer = trip.measurements.findLast(
                    ({ sensor_data }) =>
                        sensor_data.tachograph_odometer || sensor_data.odometer
                )
                trip.last_odometer_value =
                    lastWithOdometer?.sensor_data.tachograph_odometer ||
                    lastWithOdometer?.sensor_data.odometer
            }
        }

        commit('setTrips', Object.freeze(trips))
        commit('setLoadingTrips', false)
    },
}

const mutations = {
    setLoadingTrips(state, data) {
        state.isLoadingTrips = data
    },
    setSelectedTripId(state, data) {
        state.selectedTripId = data
    },
    setTripDirectionVisible(state, data) {
        state.isTripDirectionVisible = data
    },
    setTrips(state, data) {
        state.trips = data
    },
    toggleTripDirections(state) {
        state.isTripDirectionVisible = !state.isTripDirectionVisible
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
